import React from "react";

const ToolSettingIcon = ({ className = "", width = 64, height = 64, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M24.7806 30.6112L9.57369 45.7768C7.47544 47.8753 7.47544 51.2877 9.57369 53.3861C11.6719 55.4845 15.084 55.4845 17.1822 53.3861L32.3888 38.2208L24.7806 30.6112ZM15.9186 49.2117C15.3932 49.7372 14.5423 49.7372 14.0169 49.2117C13.4915 48.6863 13.4915 47.8351 14.0169 47.3097L22.1746 39.1496C22.6999 38.6242 23.5511 38.6242 24.0764 39.1496C24.6017 39.675 24.6017 40.5262 24.0764 41.0516L15.9186 49.2117ZM53.5128 11.7598L51.1942 9.44091C50.9821 9.2288 50.7052 9.09366 50.4076 9.05698C50.1099 9.02029 49.8085 9.08415 49.5513 9.23842L42.4187 13.5179C41.6683 13.9682 41.5408 15.0037 42.1595 15.6225L42.7273 16.1901L26.7007 32.5316L30.5056 36.3369L46.5322 19.9954L47.3319 20.7954C47.9507 21.4141 48.9862 21.2867 49.4363 20.5362L53.7154 13.4029C53.8696 13.1456 53.9334 12.8442 53.8967 12.5465C53.86 12.2488 53.7249 11.9719 53.5128 11.7598Z"
        fill="#B3B4B6"
      />

      <foreignObject x="-3.96719" y="-3.99999" width="71.9734" height="72">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_0_4060_115483_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <path
        data-figma-bg-blur-radius="10.6"
        d="M15.1436 7.67871C18.7722 6.68195 22.6141 7.67519 25.3125 10.376L25.5566 10.6279C28.0275 13.2711 28.9783 17.043 28.041 20.5605L27.9365 20.9541L43.0605 36.0947C47.4961 35.0215 51.0513 36.1282 53.6357 38.7148L53.8848 38.9727C56.405 41.6687 57.2826 45.4054 56.3311 48.8818C56.2341 49.2371 56.0453 49.5606 55.7842 49.8203C55.5555 50.0477 55.278 50.2194 54.9736 50.3223L54.8408 50.3623C54.4843 50.457 54.1091 50.4562 53.7529 50.3604C53.3969 50.2645 53.0723 50.077 52.8115 49.8164L49.0322 46.0381V46.0371C48.2358 45.2384 46.8632 45.224 46.042 46.041C45.2242 46.863 45.217 48.1924 46.0469 49.0244H46.0459L49.8223 52.8008L49.916 52.9014C50.1282 53.1428 50.2829 53.4298 50.3672 53.7412C50.4635 54.097 50.465 54.4717 50.3711 54.8281V54.8291C50.2769 55.1854 50.0904 55.5106 49.8311 55.7725C49.5715 56.0344 49.2472 56.2237 48.8916 56.3213C45.3843 57.2836 41.6679 56.3894 38.9824 53.874L38.7256 53.626C36.1073 51.0074 35.0365 47.4815 36.1035 43.0508L20.9756 27.9062C16.5369 28.9822 12.9856 27.8715 10.4023 25.2861C7.69053 22.5738 6.72388 18.7091 7.70605 15.1201C7.803 14.7646 7.99165 14.4405 8.25293 14.1807C8.51441 13.9208 8.84001 13.7344 9.19629 13.6396C9.55281 13.5449 9.92797 13.5447 10.2842 13.6406C10.6403 13.7365 10.9648 13.9247 11.2256 14.1855L15.0039 17.9648H15.0049C15.8092 18.7713 17.1843 18.774 17.9932 17.9629C18.8127 17.1411 18.8209 15.8103 17.9912 14.9775L14.2129 11.1992C13.9525 10.939 13.7652 10.615 13.6689 10.2598C13.5727 9.90409 13.5712 9.52919 13.665 9.17285V9.17188C13.7592 8.81548 13.9457 8.49045 14.2051 8.22852C14.4645 7.96651 14.788 7.77633 15.1436 7.67871Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#paint0_linear_4060_115483)"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <foreignObject x="8.14062" y="8.17188" width="47.7188" height="47.7011">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(8.25px)",
            clipPath: "url(#bgblur_1_4060_115483_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <g filter="url(#filter1_d_4060_115483)" data-figma-bg-blur-radius="16.5">
        <path
          d="M24.9994 25.0307C25.4778 24.5523 26.2538 24.5523 26.7322 25.0307L39.002 37.2812C39.4803 37.7596 39.4803 38.5358 39.002 39.0142C38.5236 39.4926 37.7475 39.4926 37.2692 39.0142L24.9994 26.7637C24.521 26.2852 24.521 25.5091 24.9994 25.0307Z"
          fill="url(#paint1_linear_4060_115483)"
        />
      </g>

      <defs>
        <clipPath id="bgblur_0_4060_115483_clip_path" transform="translate(3.96719 3.99999)">
          <path d="M15.1436 7.67871C18.7722 6.68195 22.6141 7.67519 25.3125 10.376L25.5566 10.6279C28.0275 13.2711 28.9783 17.043 28.041 20.5605L27.9365 20.9541L43.0605 36.0947C47.4961 35.0215 51.0513 36.1282 53.6357 38.7148L53.8848 38.9727C56.405 41.6687 57.2826 45.4054 56.3311 48.8818C56.2341 49.2371 56.0453 49.5606 55.7842 49.8203C55.5555 50.0477 55.278 50.2194 54.9736 50.3223L54.8408 50.3623C54.4843 50.457 54.1091 50.4562 53.7529 50.3604C53.3969 50.2645 53.0723 50.077 52.8115 49.8164L49.0322 46.0381V46.0371C48.2358 45.2384 46.8632 45.224 46.042 46.041C45.2242 46.863 45.217 48.1924 46.0469 49.0244H46.0459L49.8223 52.8008L49.916 52.9014C50.1282 53.1428 50.2829 53.4298 50.3672 53.7412C50.4635 54.097 50.465 54.4717 50.3711 54.8281V54.8291C50.2769 55.1854 50.0904 55.5106 49.8311 55.7725C49.5715 56.0344 49.2472 56.2237 48.8916 56.3213C45.3843 57.2836 41.6679 56.3894 38.9824 53.874L38.7256 53.626C36.1073 51.0074 35.0365 47.4815 36.1035 43.0508L20.9756 27.9062C16.5369 28.9822 12.9856 27.8715 10.4023 25.2861C7.69053 22.5738 6.72388 18.7091 7.70605 15.1201C7.803 14.7646 7.99165 14.4405 8.25293 14.1807C8.51441 13.9208 8.84001 13.7344 9.19629 13.6396C9.55281 13.5449 9.92797 13.5447 10.2842 13.6406C10.6403 13.7365 10.9648 13.9247 11.2256 14.1855L15.0039 17.9648H15.0049C15.8092 18.7713 17.1843 18.774 17.9932 17.9629C18.8127 17.1411 18.8209 15.8103 17.9912 14.9775L14.2129 11.1992C13.9525 10.939 13.7652 10.615 13.6689 10.2598C13.5727 9.90409 13.5712 9.52919 13.665 9.17285V9.17188C13.7592 8.81548 13.9457 8.49045 14.2051 8.22852C14.4645 7.96651 14.788 7.77633 15.1436 7.67871Z" />
        </clipPath>

        <filter
          id="filter1_d_4060_115483"
          x="8.14062"
          y="8.17188"
          width="47.7188"
          height="47.7011"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3.50204" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4060_115483" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4060_115483" result="shape" />
        </filter>

        <clipPath id="bgblur_1_4060_115483_clip_path" transform="translate(-8.14062 -8.17188)">
          <path d="M24.9994 25.0307C25.4778 24.5523 26.2538 24.5523 26.7322 25.0307L39.002 37.2812C39.4803 37.7596 39.4803 38.5358 39.002 39.0142C38.5236 39.4926 37.7475 39.4926 37.2692 39.0142L24.9994 26.7637C24.521 26.2852 24.521 25.5091 24.9994 25.0307Z" />
        </clipPath>

        <linearGradient
          id="paint0_linear_4060_115483"
          x1="24.1715"
          y1="20.2458"
          x2="65.1873"
          y2="64.5694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.35" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_4060_115483"
          x1="20.2796"
          y1="20.2831"
          x2="41.7992"
          y2="19.2218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ToolSettingIcon;
